









































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';

@Component({
  name: 'dynamic-document-lock-event-configuration-template',
  components: {AmetrasCheckBoxTemplate, AmetrasTextFieldTemplate}
})
export default class DynamicDocumentLockEventConfigurationTemplate extends Vue {

  @Prop({required: true}) value!: DisguiseDto.DynamicDocumentLockEventDto;
  innerValue: DisguiseDto.DynamicDocumentLockEventDto | null = null;

  created() {
    this.innerValue = this.value;
  }

  @Watch('value') valueChanged(newValue: DisguiseDto.DynamicDocumentLockEventDto) {
    this.innerValue = newValue;
  }

  @Watch('innerValue') innerValueChanged(newValue: DisguiseDto.DynamicDocumentLockEventDto) {
    this.$emit('input', newValue);
  }

  toggleOptionalUserConfirmation() {
    if (this.innerValue) {
      this.innerValue = {
        ...this.innerValue,
        optionalUserConfirmation: this.innerValue.optionalUserConfirmation !== undefined
            ? undefined
            : {}
      };
    }
  }

  toggleOptionalResultMessage() {
    if (this.innerValue) {
      this.innerValue = {
        ...this.innerValue,
        optionalResultMessage: this.innerValue.optionalResultMessage !== undefined
            ? undefined
            : {}
      };
    }
  }


}
